import React, { useEffect, useState, createContext, useContext } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from './authConfig';
import { setAuthToken, clearAuthToken } from './util/authToken';

const API_BASE_URL = process.env.REACT_APP_HOST_URL;
export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const { instance, inProgress } = useMsal();
    const [isTokenReady, setIsTokenReady] = useState(false);
    const [role, setRole] = useState(null);
    const activeAccount = inProgress === InteractionStatus.None ? instance.getActiveAccount() : null;
    useEffect(() => {
        const generateAccessToken = async (idToken) => {
            if (idToken) {
                // set auth token based on active account
                try {
                    const res = await fetch(API_BASE_URL + '/generateAccessToken', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${idToken}`
                        }
                    })
                    const data = await res.json();
                    setAuthToken(data.access_token);
                    setRole(data.role);
                    setIsTokenReady(true);
                } catch (error) {
                    console.error("Error generating access token", error);
                    clearAuthToken();
                    setIsTokenReady(false);
                }
            }
        };

        const refreshToken = () => {
            if (activeAccount) {
                instance.acquireTokenSilent({
                    ...loginRequest,
                    account: activeAccount,
                    forceRefresh: true
                }).then(response => {
                    generateAccessToken(response.idToken);
                }).catch(err => {
                    console.error("Error acquiring token silently", err);
                    clearAuthToken();
                    setIsTokenReady(false);
                });         
            }
        };

        refreshToken();
        const interval = setInterval(refreshToken, 45 * 60 * 1000);
        return () => clearInterval(interval);
    }, [activeAccount]);

    return (
        <AuthContext.Provider value={{ isTokenReady, role }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;